module.exports = __webpack_public_path__ + "static/media/saint-pierre-and-miquelon.d0985ab6.svg";